import React, { useState, useEffect, useContext } from "react";
import AddIcon from "@mui/icons-material/Add";
import { TableCell, TableRow } from "@mui/material";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import TableScrollDiv from "../../../../common/component/table/TableScrollDiv";
import EmptyData from "../modal/EmptyData";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { useNavigate } from "react-router-dom";
import { StoreContext } from "../../../../store";
import instance from "../../../../common/api/interceptor";
import { path } from "../../../../constants/apiPath";
import moment from "moment";
import FieldDate from "../../../../common/component/form/FieldDate";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "@mui/material/TextField";
import { useLocation } from "react-router-dom";
import useExcel from "../../../../common/hooks/useExcel";
import Autocomplete from "@mui/material/Autocomplete";
import modalOrderLine from "../../../../constants/data/ModalOrderLine";
import Incomplete_svg from "../../../../svg/svg-modal/Incomplete_svg";
// import routeConstant from "../../../../routes/utils/routeConstant";
import { NotificationManager } from "react-notifications";
import { LOCAL_STORAGE_KEY } from "../../../../../config";
import routeConstant from "../../../../../route/compoent/routeConstant";
import Loading from "../../../loading/Loading";
import DocumentModal from "./upload/DocumentModal";

function OrderLine() {
  const column = [
    "Line No.",
    "Item No.",
    "Description",
    "Inner Packs",
    "Inner Package Type",
    "Outer pack",
    "Outer Package Type",
    //
    "Outer Pack Length",
    "Outer Pack Width",
    "Outer Pack Height",
    "Unit Of Dimenssions",
    //
    "Qty. Ordered",
    "Qty. Received",
    "Qty. Remaining",
    "Unit Of Qty.",

    //
    "Actual Volume",
    "Unit of Volume",
    "Actual Weight",
    "Unit of Weight",

    "Item Price",
    "Total Price",
    "Req. in Store Date",
    "INCO term",
    "Additional Terms",
    "Confirm Number",
    "Container Number",
    "Confirm Date",
    "Delete",
  ];
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const [edit, setEdit] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [orderLineJson, setOrderLineJson] = useState([]);

  const onAddHandler = () => {
    const arr = [...orderLineJson];
    arr.push({ ...modalOrderLine });
    setOrderLineJson([...arr]);

    console.log(arr);
  };

  useEffect(() => {
    if (!location.state) {
      if (location.pathname.includes(routeConstant.ORDER_LIST)) {
        navigate(routeConstant.ORDER_LIST_PLACED, { replace: true });
      } else if (location.pathname.includes(routeConstant.ORDER_DASHBOARD)) {
        navigate(routeConstant.ORDER_DASHBOARD, { replace: true });
      }
    } else {
      setInputDisabled(!context.orderUserAccess?.EditOrderLine);

      const orderLine = JSON.parse(
        JSON.stringify(location.state.editOrderJSON.OrderLinesCollection ?? [])
      );

      const data = context.defaultValue;
      orderLine.map((ele, index, arr) => {
        arr[index].LineIncoTerms = {
          Description: ele.LineIncoTerms,
          Code: ele.LineIncoTerms,
        };

        arr[index].LineInnerPacksUnit = {
          Description: ele.LineInnerPacksUnit,
          Code: ele.LineInnerPacksUnit,
        };

        arr[index].LineOuterPacksUnit = {
          Description: ele.LineOuterPacksUnit,
          Code: ele.LineOuterPacksUnit,
        };

        arr[index].UnitOfDimension = {
          Description: ele.UnitOfDimension,
          Unit: ele.UnitOfDimension,
        };

        arr[index].UnitOfQuantity = {
          Description: ele.UnitOfQuantity,
          Unit: ele.UnitOfQuantity,
        };

        arr[index].LineUnitOfVolume = {
          Description: ele.LineUnitOfVolume,
          Unit: ele.LineUnitOfVolume,
        };

        arr[index].LineUnitOfWeight = {
          Description: ele.LineUnitOfWeight,
          Unit: ele.LineUnitOfWeight,
        };
      });
      setOrderLineJson([...orderLine]);
    }
  }, [location.state]);

  const onNextHandler = (path) => {
    const body = {
      ...location.state.editOrderJSON,
      OrderLinesCollection: [...orderLineJson],
      OrderNotesCollection: [],
    };

    context.setEditOrderJSON({ ...body });
    console.log("orderLineJSON", body);

    if (path) {
      navigate(path, {
        state: { edit: edit, editOrderJSON: body },
      });
    }
  };

  const onDeleteHandler = (row, index) => {
    const arr = [...orderLineJson];
    if (row.LinePk) {
      const url = `${path.DELETE_ORDER_LINE}?orderPK=${location.state.editOrderJSON.OrderHeader.OrderPK}&orderLinePK=${row.LinePk}`;
      instance
        .delete(url)
        .then((res) => {
          if (res.Is_Success) {
            arr.splice(index, 1);

            console.log({ arr });
            setOrderLineJson([...arr]);
            context.setEditOrderJSON({
              ...location.state.editOrderJSON,
              OrderLinesCollection: [...arr],
            });
            NotificationManager.success(res.Message, "", 3000);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      arr.splice(index, 1);
      setOrderLineJson([...arr]);
    }
  };

  const onLineValueChange = (lable, value, index) => {
    const arr = [...orderLineJson];
    arr[index][lable] = value;
    setOrderLineJson([...arr]);
  };

  const calculateRemain = (recived, total, index) => {
    const arr = [...orderLineJson];
    if (recived && total) {
      arr[index].LineRemainingQuantity = parseInt(total) - parseInt(recived);
    } else {
      arr[index].LineRemainingQuantity = "";
    }
    setOrderLineJson([...arr]);
  };

  const calculateTotal = (price, quantity, index) => {
    const arr = [...orderLineJson];

    if (price && quantity) {
      arr[index].LineTotalPrice = parseInt(quantity) * parseInt(price);
    }
  };

  if (!location.state) return <Loading />;
  // -----------
  return (
    <LayoutCreateOrder
      onNextHandler={onNextHandler}
      title="Edit Order"
      editComp={true}
    >
      <div className="_form-div">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 _orderLineCol">
              <div className="_orderLineHeading">
                <h5>Order Line</h5>
                {inputDisabled ? (
                  ""
                ) : (
                  <div className="_outlineButton">
                    <button
                      className="_orderSplitButton"
                      // disabled={!context.orderUserAccess?.CreateOrderLine}
                      onClick={handleOpen}
                    >
                      Upload document
                    </button>
                    <button
                      // disabled={orderLineJson.length == 0 ? true : false}
                      className="_orderSplitButton"
                      onClick={() => {
                        onNextHandler();
                        context.setModalOpen(true);
                      }}
                    >
                      <Incomplete_svg /> <span>Split Order</span>
                    </button>
                    <button
                      disabled={!context.orderUserAccess?.CreateOrderLine}
                      onClick={onAddHandler}
                    >
                      <AddIcon /> ADD
                    </button>
                  </div>
                )}
              </div>
              <DocumentModal
                open={open}
                handleClose={handleClose}
                handleOpen={handleOpen}
              />
              <TableScrollDiv className="_orderLineTable" column={column}>
                {orderLineJson.length === 0 ? (
                  <TableRow>
                    <TableCell align="left" colSpan={column.length}>
                      No line details added
                    </TableCell>
                  </TableRow>
                ) : (
                  orderLineJson.map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <TextareaAutosize
                            disabled={inputDisabled}
                            minRows={1}
                            value={row.LinePartNumber}
                            onChange={(e) => {
                              onLineValueChange(
                                "LinePartNumber",
                                e.target.value,
                                index
                              );
                            }}
                            className="form-control"
                          />
                        </TableCell>
                        <TableCell>
                          <TextareaAutosize
                            disabled={inputDisabled}
                            onChange={(e) => {
                              onLineValueChange(
                                "LineDescription",
                                e.target.value,
                                index
                              );
                            }}
                            minRows={1}
                            value={row.LineDescription}
                            className="form-control"
                          />
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineInnerPacks}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineInnerPacks",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineInnerPacks",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              value={row.LineInnerPacksUnit}
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "LineInnerPacksUnit",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              options={context.defaultValue.packType ?? []}
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineOuterPacks}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineOuterPacks",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineOuterPacks",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "LineOuterPacksUnit",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              value={row.LineOuterPacksUnit}
                              options={context.defaultValue.packType ?? []}
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>
                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineOuterPacksLength}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineOuterPacksLength",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineOuterPacksLength",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineOuterPacksWidth}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineOuterPacksWidth",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineOuterPacksWidth",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineOuterPacksHeight}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineOuterPacksHeight",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineOuterPacksHeight",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "UnitOfDimension",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              value={row.UnitOfDimension}
                              options={
                                context.defaultValue.dimenssionsUnit ?? []
                              }
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineInvoicedQuantity}
                            onChange={(e) => {
                              calculateTotal(
                                row.LineItemPrice,
                                e.target.value,
                                index
                              );
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineInvoicedQuantity",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineInvoicedQuantity",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineRecievedQuantity}
                            onChange={(e) => {
                              let value = parseInt(e.target.value);
                              let qtOrder = parseInt(row.LineInvoicedQuantity);
                              if (value > qtOrder) value = qtOrder;
                              calculateRemain(
                                value,
                                row.LineInvoicedQuantity,
                                index
                              );
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineRecievedQuantity",
                                  Math.abs(parseInt(value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineRecievedQuantity",
                                  value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            value={row.LineRemainingQuantity}
                            // disabled={true}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineRemainingQuantity",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineRemainingQuantity",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "UnitOfQuantity",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              value={row.UnitOfQuantity}
                              options={context.defaultValue.weightType ?? []}
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9.]*"
                            value={row.LineActualVolume}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineActualVolume",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "LineUnitOfVolume",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              value={row.LineUnitOfVolume}
                              options={context.defaultValue.volumeUnit ?? []}
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9.]*"
                            value={row.LineActualWeight}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineActualWeight",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineActualWeight",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "LineUnitOfWeight",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              value={row.LineUnitOfWeight}
                              options={context.defaultValue.weightType ?? []}
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>

                        {/*  */}

                        <TableCell className="_orderLineNumber">
                          <TextField
                            disabled={inputDisabled}
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            onChange={(e) => {
                              calculateTotal(
                                e.target.value,
                                row.LineInvoicedQuantity,
                                index
                              );
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineItemPrice",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineItemPrice",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                            value={row.LineItemPrice}
                          />
                        </TableCell>
                        <TableCell className="_orderLineNumber">
                          <TextField
                            label=""
                            type="number"
                            pattern="[0-9]*"
                            // disabled={true}
                            onChange={(e) => {
                              if (parseInt(e.target.value) < 0) {
                                onLineValueChange(
                                  "LineTotalPrice",
                                  Math.abs(parseInt(e.target.value)),
                                  index
                                );
                              } else {
                                onLineValueChange(
                                  "LineTotalPrice",
                                  e.target.value,
                                  index
                                );
                              }
                            }}
                            value={row.LineTotalPrice}
                          />
                        </TableCell>
                        <TableCell className="_orderLineDateField">
                          <FieldDate
                            disableDate={inputDisabled}
                            className="form-control"
                            value={row.LineReqInStoreDate}
                            onChange={(e) => {
                              onLineValueChange("LineReqInStoreDate", e, index);
                            }}
                          />
                        </TableCell>
                        {/* incoTerm */}
                        <TableCell className="_orderLineAutoComplete">
                          <div className="width100">
                            <Autocomplete
                              disabled={inputDisabled}
                              disablePortal
                              disableClearable={false}
                              size="small"
                              onChange={(e, newValue) => {
                                onLineValueChange(
                                  "LineIncoTerms",
                                  newValue ?? { Description: "" },
                                  index
                                );
                              }}
                              value={row.LineIncoTerms}
                              options={context.defaultValue.incoTerm ?? []}
                              getOptionLabel={(option) => option.Description}
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>
                        </TableCell>

                        <TableCell>
                          <TextareaAutosize
                            disabled={inputDisabled}
                            minRows={1}
                            className="form-control"
                            value={row.LineAdditionalTerms}
                            onChange={(e) => {
                              onLineValueChange(
                                "LineAdditionalTerms",
                                e.target.value,
                                index
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextareaAutosize
                            disabled={inputDisabled}
                            minRows={1}
                            className="form-control"
                            value={row.LineConfirmNumber}
                            onChange={(e) => {
                              onLineValueChange(
                                "LineConfirmNumber",
                                e.target.value,
                                index
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextareaAutosize
                            minRows={1}
                            className="form-control"
                            disabled={inputDisabled}
                            value={row.LineContainerNumber}
                            onChange={(e) => {
                              onLineValueChange(
                                "LineContainerNumber",
                                e.target.value,
                                index
                              );
                            }}
                          />
                        </TableCell>

                        <TableCell className="_orderLineDateField">
                          <FieldDate
                            disableDate={inputDisabled}
                            className="form-control"
                            value={row.LineConfirmDate}
                            onChange={(e) => {
                              onLineValueChange("LineConfirmDate", e, index);
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <button
                            disabled={
                              !context.orderUserAccess?.DeleteOrderLine &&
                              row.LinePk
                            }
                            className="_orderLineDeleteRow"
                            onClick={() => {
                              onDeleteHandler(row, index);
                            }}
                          >
                            <DeleteIcon />
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableScrollDiv>
            </div>
          </div>
        </div>
      </div>
      <EmptyData
        orderNumber={location.state.editOrderJSON.OrderHeader.OrderNumber}
      />
    </LayoutCreateOrder>
  );
}

export default OrderLine;
